import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../common/ObjectStructures/Trasnversal';
import AddForm from './AddForm';
import PropTypes from 'prop-types';
import EditForm from './EditForm';
import AddAnswerForm from './AddAnswerForm';

const SidePanelConfigure = (props) => {
    const { t } = useTranslation();
    
    
    
    const { 
        inputParam_IsPanelOpen = null, 
        inputParam_SetterIsPanelOpen = null,     
        ticket_id = null    
    } = props;
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    



    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
       
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };


    const onClosePanel = () => {
        onDismissPanel();
    };
    const onSaveConfiguration = () => {
        onDismissPanel();
    };

    
    const addFormRef = useRef(null);
    
    

  const handleSaveButtonClick = () => {
    // Llama al método handleFormSubmit de AddForm
    if (addFormRef) {        
      addFormRef.current.handleFormSubmit();
    }
  };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        Mensajes
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton onClick={handleSaveButtonClick} styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>                        
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-cancel') }</DefaultButton>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText="adding"
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <AddAnswerForm ticket_id={ticket_id} ref={addFormRef} />    
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>

        </div>
    );
};

SidePanelConfigure.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,  
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,      
};

export default SidePanelConfigure;